import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, useLocation } from 'react-router'
import { HelmetProvider } from 'react-helmet-async'
import { AccountCartProvider } from './components/account-cart-provider'
import { AuthProvider } from './components/auth-provider'
import { MixpanelProvider } from './components/mixpanel-provider'
import { FdicBannerConditional } from './components/fdic-banner-conditional'
import SiteNavConditional from './components/site-nav-conditional'
import MobileNav from './components/mobile-nav'
import PageAnalytics from './components/page-analytics'
import GtmAnalytics from './components/gtm-analytics'
import App from './App'
import { isBusinessAccountsPath } from '@/lib/business-app-path'
import { installCsrfFetch } from '@/lib/csrf-fetch'
import { cn } from '@/lib/utils'
import './index.css'

installCsrfFetch()

function AppShell() {
  const { pathname } = useLocation()
  const accountsSelectionMobile =
    pathname === '/accounts' || isBusinessAccountsPath(pathname)
  const internalRoute =
    pathname.startsWith('/approval') || pathname.startsWith('/admin')

  return (
    <div
      {...(internalRoute ? { 'data-internal-app-shell': '' } : {})}
      className={cn(
        'flex flex-col',
        'bg-cfb-light',
        internalRoute
          ? 'h-dvh max-h-dvh overflow-hidden overscroll-none'
          : 'min-h-screen'
      )}
    >
      <FdicBannerConditional />
      <SiteNavConditional />
      <main
        className={cn(
          'flex-1 w-full bg-cfb-light mobile-page-spacing',
          accountsSelectionMobile && 'mobile-page-spacing-accounts-no-nav',
          internalRoute && 'mobile-page-spacing-internal-no-nav flex min-h-0 flex-col'
        )}
      >
        <App />
      </main>
      <MobileNav />
    </div>
  )
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <AuthProvider>
          <MixpanelProvider>
            <AccountCartProvider>
              <PageAnalytics />
              <GtmAnalytics />
              <AppShell />
            </AccountCartProvider>
          </MixpanelProvider>
        </AuthProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
)
